<template>
    <v-row>
        <v-col cols="8" offset-md="2" class="offset-left">
            <message-group-detail :messageGroup="messageGroup" />
        </v-col>
    </v-row>
</template>

<script>
import MessageGroupDetail from '../components/MessageGroupDetail';

export default {
    name: 'MessageGroupView',
    components: { MessageGroupDetail },
    props: {
        messageGroupUid: {
            type: String,
            required: true
        }
    },
    computed: {
        messageGroup() {
            return this.$store.getters.getMessageGroupByUid(
                this.messageGroupUid
            );
        }
    }
};
</script>
